import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { formatApiError } from '@/lib/api';
import { AUTH } from '@/constants/testIds';
import { Sparkles } from 'lucide-react';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const u = await login(form.email, form.password);
      const to = u.role === 'admin' ? '/admin' : (location.state?.from || '/nalog');
      navigate(to);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-[80vh] flex items-center aurora-bg grain">
      <div className="container-x py-16 max-w-md mx-auto">
        <div className="bg-white border border-slate-200 rounded-3xl p-8 shadow-sm">
          <div className="inline-flex items-center gap-2 font-display font-extrabold text-xl">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-2xl text-white"
              style={{ background: 'linear-gradient(135deg, #023E8A 0%, #5B21B6 100%)' }}>
              <Sparkles className="w-5 h-5" />
            </span>
            Dubinko
          </div>
          <h1 className="font-display text-3xl font-bold mt-4">Dobrodošli nazad</h1>
          <p className="text-slate-600 mt-1">Prijavite se na svoj nalog.</p>

          <form onSubmit={submit} className="mt-6 space-y-4" data-testid={AUTH.loginForm}>
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-2">Email</label>
              <input data-testid={AUTH.loginEmail} type="email" required
                value={form.email} onChange={(e) => setForm({...form, email: e.target.value})}
                className="w-full px-4 py-3 rounded-2xl border border-slate-300 outline-none focus:border-blue-700" />
            </div>
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-2">Lozinka</label>
              <input data-testid={AUTH.loginPassword} type="password" required
                value={form.password} onChange={(e) => setForm({...form, password: e.target.value})}
                className="w-full px-4 py-3 rounded-2xl border border-slate-300 outline-none focus:border-blue-700" />
            </div>
            {error && <div data-testid={AUTH.errorMessage} className="px-4 py-3 rounded-xl bg-red-50 text-red-700 text-sm">{error}</div>}
            <button data-testid={AUTH.loginSubmit} type="submit" disabled={loading}
              className="w-full btn-primary py-3 rounded-full font-semibold disabled:opacity-60">
              {loading ? 'Prijavljujem…' : 'Prijava'}
            </button>
          </form>

          <div className="text-center text-sm text-slate-600 mt-5">
            Nemate nalog?{' '}
            <Link to="/registracija" className="font-semibold text-blue-700 hover:underline">Registrujte se</Link>
          </div>
        </div>
      </div>
    </main>
  );
}
